import React, { useState } from "react";
import uniq from "lodash/uniq";
const usePreferredSections = () => {
  const [preferredSections, setPreferredSections] = useState<string[]>([]);

  const handleAddPreferredSection = (sections: string) => {
    setPreferredSections((preferredSections) =>
      uniq([...preferredSections, ...sections.split(",")])
    );
  };

  const handleRemovePreferredSection = (toBeRemoved: string) => {
    const toBeRemovedSections = toBeRemoved.split(",");
    setPreferredSections((preferredSections) => {
      const newPreferredSections = preferredSections.filter(
        (section) => !toBeRemovedSections.includes(section)
      );
      return newPreferredSections;
    });
  };

  return {
    preferredSections,
    setPreferredSections,
    handleAddPreferredSection,
    handleRemovePreferredSection,
  };
};

export default usePreferredSections;
